<template>
    <div v-if="!!labelInfo" class="icon-container">
        <i @click="toggleShowLabelInfo()" class="material-icons">info</i>

        <InformativeTooltip
                v-if="showLabelInfo" :text="labelInfo"
                width="max-content" :position="labelPosition" :alignment="labelAlignment"
                :buttonText="tooltipText" buttonType="close" :callback="hideLabel"/>
    </div>
</template>

<script>
    import InformativeTooltip from "../../results/v2-components/Onboarding/InformativeTooltip";

    import * as mutation_types from '../../../store/mutation-types'
    import * as action_types from '../../../store/action-types'

    export default {
        name: "InfoIconWithLabel",
        components: { InformativeTooltip },
        props: {
            labelInfo: String,
            labelPosition: {
                type: String,
                default: 'right',
            },
            labelAlignment: {
                type: String,
                default: 'middle',
            }
        },
        data() {
            return {
                showLabelInfo: false,
                tooltipText: `<i class="material-icons">close</i>`,
                latestInfoLabelOpenDate: new Date().toISOString(),
            }
        },
        mounted() {
            this.setupInfoIconWithLabelWatcher();
        },
        methods: {
            setInfoLabelOpenDate() {
                this.latestInfoLabelOpenDate = new Date().toISOString();
                this.$store.commit(mutation_types.SET_OPEN_INFO_LABEL_DATE, this.latestInfoLabelOpenDate)
            },

            setupInfoIconWithLabelWatcher() {
                this.$store.watch(
                    () => this.$store.getters[action_types.GET_OPEN_INFO_LABEL_DATE],
                    newDate => {
                        if (newDate > this.latestInfoLabelOpenDate) {
                            this.hideLabel(0);
                        }
                    },
                    {
                        deep:true
                    }
                );
            },

            toggleShowLabelInfo() {
                if (!this.showLabelInfo) {
                    this.setInfoLabelOpenDate();
                    this.showLabelInfo = true;
                    return;
                }

                this.hideLabel(0);
            },

            async hideLabel(delay = 500) {
                await this.timeout(delay);
                this.showLabelInfo = false;
            },
        }
    }
</script>

<style lang="scss">
    .icon-container {
        position: relative;
        display: flex;
        cursor: pointer;

        .informative-tooltip {
            .tool-tip {
                display: flex;
                align-items: center;

                .buttons {
                    margin: 0 0 0 4px;

                    .close {
                        opacity: 1;

                        &:hover i {
                            opacity: 1;
                        }

                        i {
                            font-size: 16px;
                            color: #fff;
                            opacity: .5;
                        }
                    }
                }

                .text {
                    padding: 0;
                    font-weight: 400;

                    a {
                        color: $light-blue;
                        text-decoration: underline;
                    }
                }
            }
        }
    }
</style>